module.exports = __webpack_public_path__ + "img/sw.d8544ac1.png";